export default "/assets/images/home-wrecker-crop1.5caaac8673956f24.png";